import React from "react";
var __jsx = React.createElement;
import classes from "./AffSection5.module.css";
import { useTranslation } from "@i18n";
var AffSection5 = function AffSection5() {
  var _useTranslation = useTranslation(["web_affiliate_program", "web_common"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("section", {
    className: classes.AffiliateSection4
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", classes.containerMaxWidth].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.blueBanner
  }, /*#__PURE__*/React.createElement("strong", null, t("join_syarah_affiliate", {
    ns: "web_affiliate_program"
  }), /*#__PURE__*/React.createElement("br", null), t("program", {
    ns: "web_affiliate_program"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://syarah.trackier.com/register.html",
    className: ["redBtn", classes.mrkALink].join(" ")
  }, t("start_earning_today", {
    ns: "web_affiliate_program"
  })))));
};
export default AffSection5;